const projectData = [
  {
    id: 1,
    imgage:'https://res.cloudinary.com/drrqslttj/image/upload/v1643207866/portfoilo/projects/movie-db_vhirjz.png',
    title: 'Movie / Show DB',
    description : 'A movie / show React application that allows users to search for movies and shows.',
    link: 'https://movies-shows-db.netlify.app/',
    github: 'https://github.com/Mayur-Arde/Find-Movies-Shows-db'
  },
  {
    id: 2,
    imgage:'https://res.cloudinary.com/drrqslttj/image/upload/v1643207895/portfoilo/projects/notes-pad-dark_bho5yv.png',
    title: 'Note Taker',
    description : 'A simple notes app built with React.js, with dark mode and a search feature.',
    link: 'https://react-notes-pad.netlify.app/',
    github: 'https://github.com/Mayur-Arde/react-notepad'
  },
  {
    id: 3,
    imgage:'https://res.cloudinary.com/drrqslttj/image/upload/v1643207883/portfoilo/projects/netflix-clone_zx4lsi.png',
    title: 'Netflix Home Clone',
    description : 'A clone of Netflix home page built with React, use TMDB API and deploy with firebase.',
    link: 'https://netflix-clone-mayur-arde.web.app/',
    github: 'https://github.com/Mayur-Arde/netflix-home-clone'
  },
  {
    id: 4,
    imgage:'https://res.cloudinary.com/drrqslttj/image/upload/v1643207892/portfoilo/projects/food-menu_jrpwjq.png',
    title: 'Food Menu',
    description : 'A food menu application that allows users to sort and filter the menu items.',
    link: 'https://mayurarde.hashnode.dev/',
    github: ''
  },
  {
    id: 5,
    imgage:'https://res.cloudinary.com/drrqslttj/image/upload/v1643207896/portfoilo/projects/grocery-list_ctmud2.png',
    title: 'Grocery List',
    description : 'A simple grocery list app built with it helps you to keep track of your grocery list.',
    link: 'https://grocery-bucket.netlify.app/',
    github: 'https://github.com/Mayur-Arde/Grocery'
  },
  {
    id: 6,
    imgage:'https://res.cloudinary.com/drrqslttj/image/upload/v1643207885/portfoilo/projects/exchange-rate-calculator_birctv.png',
    title: 'Exchange Rate Calculator',
    description : 'A simple exchange rate calculator built with JavaScript, calculates the exchange rate of a currency.',
    link: 'https://exchange-rate-cal-mayur.netlify.app//',
    github: 'https://github.com/Mayur-Arde/Exchange-rate-calculator'
  },
  {
    id: 7,
    imgage:'https://res.cloudinary.com/drrqslttj/image/upload/v1643207898/portfoilo/projects/reviews-react_fjcp9o.png',
    title: 'Reviews Card',
    description : 'A simple reviews app built with React.slider to show the reviews of a product.',
    link: 'https://review-component.netlify.app/',
    github: 'https://github.com/Mayur-Arde/Reviews'
  },
  {
    id: 8,
    imgage:'https://res.cloudinary.com/drrqslttj/image/upload/v1643207913/portfoilo/projects/tour-planner_cgmwe9.png',
    title: 'Tours planner',
    description : 'A simple tour planner app built with React.Plan your tour with the help of the website.',
    link: 'https://tours-planner.netlify.app/',
    github: 'https://github.com/Mayur-Arde/Tours-plan'
  },
  {
    id: 9,
    imgage:'https://res.cloudinary.com/drrqslttj/image/upload/v1643207913/portfoilo/projects/tour-planner_cgmwe9.png',
    title: 'Frontend Mentor Challenges',
    description : 'Contains all the challenges form the Frontend Mentor under one website.',
    link: 'https://all-frontend-mentor-projects-mayur.netlify.app/',
    github: 'https://github.com/Mayur-Arde/Frontend-Mentor-Html-css-Projects'
  },
  {
    id: 10,
    imgage:'https://res.cloudinary.com/drrqslttj/image/upload/v1643207889/portfoilo/projects/foodies-bootstrap_boauav.png',
    title: 'Foodeis Landing Page',
    description : 'A landing page for a foodie application, built with only Bootstrap.',
    link: 'https://foodies-bootstrap.netlify.app/',
    github: 'https://github.com/Mayur-Arde/foodies'
  },

  
];

export default projectData;